const initState = () => {
  return {
    appName: "",
    folderId: null,
    folderName: "",
    projectId: "",
    projectName: "",
    username: "",
    userInfo: null,
    userRole: "",
    theme: "",
    language: "",
    token: "",
    expiresIn: "",
    refreshToken: "",
    expirationTime: "",
    to_be_deleted_img: "",
  };
};
const getters = {
  getAppName(state) {
    return state.appName;
  },
  getFolderId(state) {
    return state.folderId;
  },
  getFolderName(state) {
    return state.folderName;
  },
  getProjectId(state) {
    return state.projectId;
  },
  getProjectName(state) {
    return state.projectName;
  },
  getUserInfo(state) {
    return state.userInfo;
  },
  getUserRole(state) {
    return state.userRole;
  },
  getTheme(state) {
    return state.theme;
  },
  getLanguage(state) {
    return state.language;
  },
  getUsername(state) {
    return state.username;
  },
  getToken(state) {
    return state.token;
  },
  // new
  getisInvite(state) {
    return state.isInvite;
  },
  getappid(state) {
    return state.appid;
  },
  getview(state) {
    return state.view;
  },
  getbimId(state) {
    return state.bimId;
  },
  getassetid(state) {
    return state.assetId;
  },
};
const mutations = {
  // 修改所有参数
  updateParams(state, params) {
    Object.keys(params).forEach((key) => {
      if (state[key] !== undefined) {
        let val;
        if (key === "userInfo") {
          val = JSON.parse(params[key]);
        } else {
          val = params[key];
        }
        state[key] = val;
      }
    });
  },
  // updateToken(state, token) {
  //   state.token = token;
  // },
  // 增加删除filekey属性
  deletetoImg(state) {
    delete state.to_be_deleted_img;
  },
  addtoImg(state, val) {
    state.to_be_deleted_img = val;
  },
};
const actions = {
  updateParams({ commit }, params) {
    commit("updateParams", params);
  },
};

export default {
  namespaced: true,
  state: initState,
  getters,
  mutations,
  actions,
};
